<div part="cm-config-menu-icons" class="cm-config-menu-icons" style="--icon-size: {{ $iconSize() + 'px' }}">
    <div class="cm-tabs-scroll-row">
        @if (groups.$canScrollLeft()) {
            <button
                type="button"
                part="cm-scroll-arrow cm-scroll-arrow-left"
                class="cm-scroll-arrow cm-scroll-arrow-left"
                aria-label="Scroll left"
                (click)="groups.scrollByDirection(-1)"
            >
                <i class="far fa-chevron-left"></i>
            </button>
        }
        <div part="cm-mobile-tabs-groups" class="cm-mobile-tabs-groups" cmHorizontalScrollArrows #groups="cmHorizontalScrollArrows">
            @for (desc of $configDescriptors(); track desc.props.id) {
                <div
                    [attr.part]="$activeGroup()?.props?.id === desc.props.id ? 'cm-config-group-title cm-config-group-title-active' : 'cm-config-group-title'"
                    class="cm-config-group-title"
                    [class.cm-config-group-title-active]="$activeGroup()?.props?.id === desc.props.id"
                    (click)="onGroupClicked(desc.props.id)"
                >
                    {{ desc.props.name }}
                </div>
            }
        </div>
        @if (groups.$canScrollRight()) {
            <button
                type="button"
                part="cm-scroll-arrow cm-scroll-arrow-right"
                class="cm-scroll-arrow cm-scroll-arrow-right"
                aria-label="Scroll right"
                (click)="groups.scrollByDirection(1)"
            >
                <i class="far fa-chevron-right"></i>
            </button>
        }
    </div>

    @if ($activeGroup(); as activeGroup) {
        <div class="cm-tabs-scroll-row">
            @if (variants.$canScrollLeft()) {
                <button
                    type="button"
                    part="cm-scroll-arrow cm-scroll-arrow-left"
                    class="cm-scroll-arrow cm-scroll-arrow-left"
                    aria-label="Scroll left"
                    (click)="variants.scrollByDirection(-1)"
                >
                    <i class="far fa-chevron-left"></i>
                </button>
            }
            <div
                [attr.part]="activeGroup.props.displayWithLabels ? 'cm-labels-container' : 'cm-icons-container'"
                [class.cm-labels-container]="activeGroup.props.displayWithLabels"
                [class.cm-icons-container]="!activeGroup.props.displayWithLabels"
                cmHorizontalScrollArrows
                #variants="cmHorizontalScrollArrows"
            >
                @for (variant of activeGroup.props.variants; track variant.id) {
                    <cm-config-button
                        [asLabel]="activeGroup.props.displayWithLabels"
                        [tooltipContainer]="$tooltipContainer()"
                        [config]="activeGroup"
                        [variant]="variant"
                        [useCaptions]="$useCaptions()"
                        [selectedVariant]="activeGroup.props.value ?? undefined"
                        (click)="onVariantClicked(activeGroup, variant)"
                    ></cm-config-button>
                }
            </div>
            @if (variants.$canScrollRight()) {
                <button
                    type="button"
                    part="cm-scroll-arrow cm-scroll-arrow-right"
                    class="cm-scroll-arrow cm-scroll-arrow-right"
                    aria-label="Scroll right"
                    (click)="variants.scrollByDirection(1)"
                >
                    <i class="far fa-chevron-right"></i>
                </button>
            }
        </div>
    }
</div>
